import { useEffect, useState } from "react";
import {
  APP_LOGO_UPDATED_EVENT,
  getStoredAppLogo,
} from "../utils/appBranding";

export const useAppLogo = () => {
  const [appLogo, setAppLogo] = useState<string | null>(() => getStoredAppLogo());

  useEffect(() => {
    const syncLogo = () => {
      setAppLogo(getStoredAppLogo());
    };

    window.addEventListener("storage", syncLogo);
    window.addEventListener(APP_LOGO_UPDATED_EVENT, syncLogo as EventListener);

    return () => {
      window.removeEventListener("storage", syncLogo);
      window.removeEventListener(
        APP_LOGO_UPDATED_EVENT,
        syncLogo as EventListener
      );
    };
  }, []);

  return appLogo;
};
